import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { KVCameraView, KVCameraViewJSON, RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

export function getNewCameraViewMessage() {
  return {
    type: 'cameraView',
    requiredData: ['cameraViewId'],

    callback: (json: KVCameraViewJSON, kv: KestrelViewerMessageCallbackAPI) => {
      const cameraView = KVCameraView.fromJSON(json)
      const newKVCameraViews = [...(kv.cameraViews ?? []), cameraView]
      kv.setCameraViews(newKVCameraViews)

      // Send to Rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data: {
          cameraViews:
            newKVCameraViews?.map((m) => KVCameraView.toJSON(m)) ?? [],
        },
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
